import FullModifierViewModel from './FullModifierViewModel'
import { formatCartItemModifiers, displayPreOrdersItemPrice } from '../utils/formatters'
import { OPEN_PRICE_REASON } from '../VNItems/consts'

const PreOrdersItemViewModel = (lineItem, refunded = false) => {
  const modifiers = lineItem?.modifiers ?? [[]]
  const notes = lineItem?.notes ?? null
  const safePrice = lineItem?.price || '0.00'
  let filteredModifiers

  if (refunded) {
    filteredModifiers = modifiers[0]?.filter((modifier) => modifier.removedAt)
  } else {
    filteredModifiers = modifiers[0]?.filter((modifier) => !modifier.removedAt)
  }

  const model = {
    id: lineItem.menuItemUuid,
    name: lineItem.name,
    price: displayPreOrdersItemPrice(lineItem, modifiers[0]),
    color: null,
    priceInCents: parseInt(safePrice.replace('.', '')),
    lineItemUuid: lineItem.uuid,
    quantity: lineItem.quantity,
    fractionalQuantity: lineItem.fractionalQuantity,
    modifiersString: '',
    refund: !!lineItem.removedAt,
  }

  // item-level approverUuid and reason
  if (lineItem.approverUuid) {
    model.approverUuid = lineItem.approverUuid
    model.reason = lineItem.reason
  }

  if (lineItem.type) {
    model.type = lineItem.type
  }

  // open price item flag
  if (lineItem.reason === OPEN_PRICE_REASON) {
    model.openPrice = true
  }

  if (filteredModifiers.length) {
    model.modifiers = filteredModifiers.map((modifier) => {
      return FullModifierViewModel({
        ...modifier,
        modifiedLineItemUuid: lineItem.uuid,
      })
    })
    model.modifiersString = formatCartItemModifiers(model.modifiers, notes)
  }

  if (lineItem.originalPrice) {
    const safeOriginaLPrice = lineItem?.originalPrice || '0.00'
    model.originalPriceInCents = parseInt(safeOriginaLPrice.replace('.', ''))
  } else {
    model.originalPriceInCents = null
  }

  return model
}

export default PreOrdersItemViewModel
